// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type ApplyConfigurationCard_ReadyPlanConfigLike_CheckoutConfig_Fragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], productOffering?: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, readyPlan?:
    | { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined }
   | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, maybeShortName: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean, isSpecLevel: boolean } }> };

export type ApplyConfigurationCard_ReadyPlanConfigLike_ProductOfferingConfig_Fragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], productOffering: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }, readyPlan:
    | { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined }
  , readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, maybeShortName: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean, isSpecLevel: boolean } }> };

export type ApplyConfigurationCard_ReadyPlanConfigLike_ProjectReadyPlanConfig_Fragment = { __typename?: 'ProjectReadyPlanConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], productOffering?: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, readyPlan?:
    | { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined }
   | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, maybeShortName: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean, isSpecLevel: boolean } }> };

export type ApplyConfigurationCard_ReadyPlanConfigLikeFragment =
  | ApplyConfigurationCard_ReadyPlanConfigLike_CheckoutConfig_Fragment
  | ApplyConfigurationCard_ReadyPlanConfigLike_ProductOfferingConfig_Fragment
  | ApplyConfigurationCard_ReadyPlanConfigLike_ProjectReadyPlanConfig_Fragment
;

export type ApplyConfigurationCard_AggregateVersionFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string, displayVersion: string };

export type ApplyConfigurationCard_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, maybeShortName: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean, isSpecLevel: boolean } };

export const ApplyConfigurationCard_ReadyPlanOptionFragmentDoc = gql`
    fragment ApplyConfigurationCard_ReadyPlanOption on ReadyPlanOption {
  id
  maybeShortName
  type {
    id
    isElevation
    isExteriorScheme
    isInteriorScheme
    isSpecLevel
  }
}
    `;
export const ApplyConfigurationCard_ReadyPlanConfigLikeFragmentDoc = gql`
    fragment ApplyConfigurationCard_ReadyPlanConfigLike on ReadyPlanConfigLike {
  id
  name
  updatedAt
  productOffering {
    id
    coverAsset {
      id
      previewUrl(resizing: {width: 321, region: FULL})
    }
  }
  readyPlan {
    id
    name
    code
  }
  readyPlanOptions {
    ...ApplyConfigurationCard_ReadyPlanOption
  }
}
    ${ApplyConfigurationCard_ReadyPlanOptionFragmentDoc}`;
export const ApplyConfigurationCard_AggregateVersionFragmentDoc = gql`
    fragment ApplyConfigurationCard_AggregateVersion on ReadyPlanAggregateVersion {
  id
  name
  displayVersion
}
    `;